import styled, { css } from "styled-components";

export const Wrap = styled.section`
  background: transparent;
  color: #111;
  padding: 36px 6px 0px 12px;
`;

export const Inner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.1fr 1fr;
  gap: clamp(20px, 4vw, 48px);
  @media (max-width: 940px) {
    grid-template-columns: 1fr;
  }
`;

export const Left = styled.div``;

export const Eyebrow = styled.div`
  color: #a78631;
  font-weight: 700;
  letter-spacing: 0.3px;
  margin-bottom: 8px;
  font-size: 18px;
  @media (max-width: 900px) {
    font-size: 14px;
  }
`;

export const Title = styled.h3`
  margin: 0 0 10px;
  font-size: 30px;
  line-height: 1.15;
  font-weight: 900;
`;

export const Text = styled.p`
  margin: 0 0 16px;
  font-size: clamp(14px, 1.7vw, 18px);
  line-height: 1.7;
  opacity: 0.95;
`;

export const Actions = styled.div`
  margin-top: 6px;
`;

export const Btn = styled.button`
  background: #111;
  color: #fff;
  border: 0;
  border-radius: 12px;
  padding: 12px 18px;
  font-weight: 800;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  transition: transform 0.15s ease, filter 0.15s ease;
  &:hover {
    transform: translateY(-1px);
    filter: brightness(1.05);
  }
`;

export const Right = styled.div`
  position: relative;
`;

export const Slider = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  box-shadow: 0 6px 26px rgba(0, 0, 0, 0.12);
  height: min(56vw, 420px);
`;

export const Slide = styled.div`
  position: absolute;
  inset: 0;
  opacity: 0;
  transform: scale(1.02);
  transition: opacity 700ms ease, transform 900ms ease;
  ${(p) =>
    p.$active &&
    css`
      opacity: 1;
      transform: scale(1);
      z-index: 1;
    `}
`;

export const Img = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const NavBtn = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${(p) => p.left && "left: 12px;"} ${(p) => p.right && "right: 12px;"}
  width:40px;
  height: 40px;
  border-radius: 999px;
  border: 0;
  background: rgba(17, 17, 17, 0.55);
  color: #fff;
  display: grid;
  place-items: center;
  cursor: pointer;
  z-index: 3;
  transition: background 0.2s ease, transform 0.2s ease;
  &:hover {
    background: rgba(17, 17, 17, 0.75);
    transform: translateY(-50%) scale(1.04);
  }
  svg {
    width: 22px;
    height: 22px;
  }
`;

export const Dots = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-top: 10px;
`;

export const Dot = styled.button`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 0;
  cursor: pointer;
  background: ${(p) => (p.$active ? "#d4af37" : "rgba(17,17,17,.35)")};
  transition: transform 0.2s ease, background 0.2s ease;
  &:hover {
    transform: scale(1.1);
  }
`;
